import React from 'react'
import { SingleDatePicker } from 'react-dates'
import { Field } from 'redux-form'
import moment from 'moment'

export const DateComponent = ({ input, meta }) => (
    <SingleDatePicker
        date={input.value}
        focused={meta.active}
        onDateChange={(value) => input.onChange({ value })}
        onFocusChange={({ focused }) => focused ? input.onFocus(true) : input.onBlur(true)}
    />
)

DateComponent.displayName = 'DateComponent'

const DateField = ({ name }) => (
    <Field
        name={name}
        component={DateComponent}
        format={(value) => value ? moment(value) : undefined}
        normalize={(data) => data && data.value && data.value.format()}
    />
)

DateField.displayName = 'DateField'

export default DateField


// WEBPACK FOOTER //
// ./src/renderDate.js